import { Box, Button, ClickAwayListener, createTheme, Fade, Paper, Popper, ThemeProvider, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const theme = createTheme({
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    padding: '10px'
                },
            }
        },
    }
})

const AlertPopup = (props: any) => {
    const { alertMessage, isOpen, handleClose, anchor, confirmMessages } = props;
    const [t] = useTranslation();

    const handleClickInsidePopper = (event: MouseEvent) => {
        event.stopPropagation();
    }

    return (
        <React.Fragment>
            <ThemeProvider theme={theme}>
                <Popper className='comfirmationPopperStyle' open={isOpen} transition anchorEl={anchor}>
                    {({ TransitionProps }) => (
                <ClickAwayListener onClickAway={() => {handleClose(false)}}>
                    <Fade {...TransitionProps} timeout={350}>
                        <Paper sx={{ boxShadow: '1px 2px 2px #ccc' }} onClick={() => handleClickInsidePopper}>
                                    <Box sx={{ 
                                    height: '100%',
                                    display: 'flex', 
                                    flexDirection: 'column',
                                    justifyContent: 'space-between' }}>
                                        <Typography sx={{ pb: '10px' }}>
                                            {alertMessage}
                                        </Typography>
                                        <Box sx={{ display: 'flex', width: '100%', justifyContent: 'flex-end' }}>
                                            <Button
                                            className={'smallButton mr20'} 
                                            disableElevation 
                                            onClick={() => {handleClose(false)}} 
                                            variant='contained' size='small' >
                                                {t('CANCEL')}
                                            </Button>
                                            {
                                                confirmMessages?.length === 2 ?
                                                <>
                                                    <Button 
                                                    className={'smallButton'} 
                                                    disableElevation 
                                                    onClick={() => {handleClose(confirmMessages[0])}} 
                                                    variant='contained' size='small'>
                                                        {confirmMessages[0]}
                                                    </Button>
                                                    <Button 
                                                    sx={{ ml: '10px' }}
                                                    className={'smallButton'} 
                                                    disableElevation 
                                                    onClick={() => {handleClose(confirmMessages[1])}} 
                                                    variant='contained' size='small'>
                                                        {confirmMessages[1]}
                                                    </Button> 
                                                </>
                                                :
                                                <Button 
                                                className={'smallButton'} 
                                                disableElevation 
                                                onClick={() => {handleClose(true)}} 
                                                variant='contained' size='small'>
                                                    {t('CONFIRM')}
                                                </Button>
                                            }
                                        </Box>
                                    </Box>
                        </Paper>
                    </Fade>
                    </ClickAwayListener>
                    )}
                </Popper>
            </ThemeProvider>
        </React.Fragment>
    )
}

export default AlertPopup;